export class PlanosContas {
    id:number;
	planoConta:string;
	codigoCategoriaContabil:string;
	idInstituicao:number;
	sintetica: boolean;
}